<div class="episode-ribbon-container" >
    <div class="ribbon-header">
        <ng-container *ngIf="!hideFormsTitle">
            <span class="formdot"></span>
            <span>Dynamic Form</span>
        </ng-container>
        <div class="ribbon-header-options-button">
            <button
                doNotPropagateClick
                type="button"
                pButton
                pRipple
                icon="mi mi-button-more"
                class="p-button-secondary p-button-rounded p-button-text"
                (click)="asyncMenu.toggle($event)"></button>
            <async-menu
                #asyncMenu
                [menuItems]="menuOptions"></async-menu>
        </div>
    </div>

    <div class="form-info">
        <span class="form-name">
            <b>{{ form.formDefinition.name }}</b>
        </span>

        <div class="form-actions">
            <p-button
                icon="pi pi-cloud-download"
                iconPos="right"
                label="View"
                styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                (onClick)="view()"></p-button>
            <p-button
                *ngIf="canEdit"
                icon="mi mi-button-edit"
                iconPos="right"
                label="Update"
                styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                (onClick)="edit()"></p-button>
            <p-button
                *ngIf="canEdit"
                icon="pi pi-check-circle"
                iconPos="right"
                label="Complete"
                styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                (onClick)="complete()"></p-button>
            <p-button
                *ngIf="canDelete"
                icon="mi mi-button-remove text-danger"
                iconPos="right"
                label="Delete"
                styleClass="hidden md:inline-flex p-button-secondary p-button-text"
                (onClick)="doDelete()"></p-button>
        </div>
    </div>

    <div class="ribbon-footer">
        <span class="sm:mr-3">{{ createdOn }}</span>
        <span class="sm:mr-1">
            Created by:
            <span> <b>{{ form.userFullName }}</b></span>
        </span>

        <span class="mr-1">
            Category: <b>{{ form.formDefinition.formCategory.name }}</b>
        </span>

        <span class="sm:mr-1">
            Owned by: <b>{{ form.organizationName }}</b>
        </span>
    </div>
</div>

<m-historical-dialog
    [visible]="showHistorical()"
    (visibleChange)="showHistorical.set($event)"
    [items]="historicalItems()"></m-historical-dialog>